//
//
//
//
//
//
//
import PageFooter from '~/components/common/PageFooter.vue';
export default {
  components: {
    PageFooter
  }
};